import { createClient } from 'contentful';
import localConfig from '@/config';

export const contentfulClient = createClient({
  space: localConfig.contentfulSpace,
  accessToken: localConfig.contentfulToken,
  host: localConfig.contentfulHost,
});
